// Party (como no Global): XP compartilhada entre quem caça na mesma hunt, com level mínimo de 2/3 do maior,
// e bônus pela diversidade de vocations (1: +20%, 2: +30%, 3: +60%, 4 ou mais: +100%).
export const PARTY_MAX = 10;
export function partyBonusPct(vocations: number): number {
  return vocations >= 4 ? 100 : vocations === 3 ? 60 : vocations === 2 ? 30 : vocations === 1 ? 20 : 0;
}
export interface PartyMember { id: number; name: string; vocation: string; level: number; hp: number; map: string; online: boolean; leader: boolean }
